import { SaldoRelation } from "./saldorelation.model"
export class BalCalcRule {
  calc_rule_id: number;
  descr: string;
  passivated: boolean;
  saldoRelations: SaldoRelation[]; // Array of SaldoRelation instances
}
